import React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { Fab, Card } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import api from "../../../components/services/api";
import SearchData from "../components/SearchData";
import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useSelector } from "react-redux";
import {
  GridToolbarContainer,
  GridToolbarExport,
  gridClasses,
} from "@mui/x-data-grid";
import DowloadBT from "../../Planner/components/dowloadBT";
export default function ContainerTALLYList() {
  const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const MenuActive = useSelector((state) => state.MenuActive.List);
  const columns = [
    { field: "Pol", headerName: "ETD POL", width: 150 },
    { field: "Voyage", headerName: "Voyage", width: 180 },
    { field: "CloseingDate", headerName: "CLOSING DATE", width: 200 },
    { field: "CloseingTime", headerName: "CLOSING TIME", width: 200 },
    { field: "qty_so", headerName: "QTY SO", width: 150 },
    { field: "TugName", headerName: "Tug", width: 180 },
    { field: "BargeName", headerName: "Barge", width: 180 },

    { field: "Weight", headerName: "Weight", width: 180 },
    { field: "TotalContainer", headerName: "Total", width: 180 },
    {
      field: "Action",
      width: 130,
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <Link
              to={{
                pathname: `/Ship/detailContainerTally/${params.row.Voyage}`,
              }}
            >
              <Button
                variant="contained"
                style={{ textTransform: "none", backgroundColor: "#007BFF" }}
                
              >
                View
              </Button>
            </Link>
          </>
        );
      },
    },
  ];
  const floating_action_style = {
    margin: 0,
    top: "auto",
    right: 20,
    bottom: 10,
    left: "auto",
    position: "fixed",
  };
  //fetch Data
  const getData = async () => {
    try {
      const data = await api.get("api/tally/list");
      console.log(data);
      setData(data.data);
      setDataFilter(data.data);
    } catch (e) {
      console.log(e);
    }
  };
  //api call
  useEffect(() => {
    // GET request using axios inside useEffect React hook
    getData();

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, []);
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        {/* <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          รายการคอนเทนเนอร์
        </h6> */}

        <Grid container alignItems="center" spacing={1} sx={{ marginTop: 3 }}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Container TALLY
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Ship</Typography>
            <Typography>
              <span>&nbsp;</span> / Container TALLY
            </Typography>
          </Grid>
        </Grid>

        <Grid
          //   container
          //   sx={{ justifyContent: "end" }}
          style={{ marginTop: "10px", display: "flex", flexDirection: "row" }}
        >
          <DowloadBT />

          <SearchData name={dataFilter} onsetData={setDataFilter} />
        </Grid>

        <Box
          sx={{
            height: 650,
            width: "100%",
            marginTop: "10px",
            "& .Active": {
              color: "#28A745",
            },
            "& .Inactive": {
              color: "#F53C56",
            },
          }}
        >
          <DataGrid
            getRowId={(r) => r.TransportHeadId}
            rows={dataFilter}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            hideFooterSelectedRowCount
            disableColumnFilter
            disableColumnMenu
            getCellClassName={(params) => {
              if (params.field === "Status") {
                return params.value == 1 ? "Active" : "Inactive";
              }
            }}
            // components={{
            //   Toolbar: CustomToolbar,
            // }}
          />
        </Box>
      </Card>
      {/* {MenuActive.find((x) => x.ActionNo === "A050") && (
        <Link to="/Ship/AddContainerTally">
          <Fab color="primary" style={floating_action_style} aria-label="add">
            <AddIcon />
          </Fab>
        </Link>
      )} */}
    </div>
  );
}
